import React from 'react';
import { withRouterProps } from 'utils/compose';
import Results from './Results';

const View = ({ appId }) => <Results id={appId} />;

export default withRouterProps(View);
